import api from '../services/api';
import { ITerminology } from '../shared/interfaces';

interface IResponseGetTerminologies {
  data: ITerminology[];
  count: number;
}
export const getTerminologies = async (
  take: number,
  skip: number,
  keyword?: string,
): Promise<IResponseGetTerminologies> => {
  const response = await api.post('/terminologies/list', {
    take,
    skip,
    keyword,
  });
  return response.data;
};

export const postTerminology = async (payload: any): Promise<ITerminology> => {
  const response = await api.post(`/terminologies`, payload);
  return response.data;
};

export const patchTerminology = async (
  id: string | undefined,
  payload: any,
): Promise<ITerminology> => {
  if (!id) {
    throw new Error('ID da terminologia não fornecido.');
  }
  const response = await api.patch(`/terminologies/${id}`, payload);
  return response.data;
};
